// extracted by css-extract-rspack-plugin
export default {"wrapper":"_c8f0fc4","subHeading":"_f417383b","heading":"_cdf8819f","bannerVideo":"_88957a32","textWrapper":"_566c8499","text":"_a43c052a","cta":"_290782e1"};